import pluralize from "pluralize";

function formatTime(
  seconds: number,
  options?: {
    addPadding?: boolean;
    pluralize?: boolean;
  }
) {
  const shouldAddPadding = options?.addPadding ?? false;
  const shouldPluralize = options?.pluralize ?? true;

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds - hours * 3600) / 60);
  const remainingSeconds = seconds - hours * 3600 - minutes * 60;

  const paddedHours = shouldAddPadding ? padNumberWithZero(hours) : hours;
  const paddedMinutes = shouldAddPadding ? padNumberWithZero(minutes) : minutes;
  const paddedSeconds = shouldAddPadding
    ? padNumberWithZero(remainingSeconds)
    : remainingSeconds;

  const hourString = shouldPluralize ? pluralize("hr", hours) : "h";
  const minuteString = shouldPluralize ? pluralize("min", minutes) : "m";
  const secondString = shouldPluralize
    ? pluralize("sec", remainingSeconds)
    : "s";

  const finalHourString = hours === 0 ? "" : `${paddedHours}${hourString}`;
  const finalMinuteString =
    minutes === 0 ? "" : `${paddedMinutes}${minuteString}`;
  const finalSecondString =
    remainingSeconds === 0 ? "" : `${paddedSeconds}${secondString}`;

  return `${finalHourString} ${finalMinuteString} ${finalSecondString}`.trim();
}

function padNumberWithZero(number: number) {
  let numberString = number.toString();
  if (numberString.length === 1) {
    numberString = "0" + numberString;
  }

  return numberString;
}

export { formatTime, padNumberWithZero };
